import React from 'react';
import AntdProForm from '@ant-design/pro-form';
import { Skeleton, ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';

const ProForm = ({
  children,
  backPage,
  previousLevel,
  loading,
  // TODO: remove disabled, to use disabledButton / hideButton
  disabled,
  // disableBackButton,
  // disableSubmitButton,
  hideBackButton,
  hideSubmitButton,
  ...rest
}) => {
  const history = useHistory();
  const location = useLocation();

  return loading ? (
    <Skeleton active />
  ) : (
    <ConfigProvider locale={enUS}>
      <AntdProForm
        onReset={() => {
          // to consider the previous page when clicking back
          // specified backPage > previous page in router history > specified previousLevel > auto guess previous level
          if (backPage) {
            history.push(backPage);
          } else if (location.state?.from) {
            history.push({
              pathname: history.location.state.from,
              hash: location.state.hash,
            });
          } else if (previousLevel) {
            history.push(previousLevel);
          } else {
            history.push(location.pathname.split('/').slice(0, -1).join('/'));
          }
        }}
        submitter={{
          render: (_, doms) => doms.reverse(),
          searchConfig: {
            resetText: 'Back',
            //   submitText: 'Submit',
          },
          resetButtonProps:
            hideBackButton || disabled
              ? {
                  style: {
                    display: 'none',
                  },
                }
              : {},
          submitButtonProps:
            hideSubmitButton || disabled
              ? {
                  style: {
                    display: 'none',
                  },
                }
              : {},
        }}
        scrollToFirstError={true}
        requiredMark="optional"
        {...rest}
      >
        {children}
      </AntdProForm>
    </ConfigProvider>
  );
};

ProForm.defaultProps = {
  loading: false,
  disabled: false,
  // disableBackButton: false,
  // disableSubmitButton: false,
  hideBackButton: false,
  hideSubmitButton: false,
};

ProForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  backPage: PropTypes.string,
  previousLevel: PropTypes.string,
  // disableBackButton: PropTypes.bool.isRequired,
  // disableSubmitButton: PropTypes.bool.isRequired,
  hideBackButton: PropTypes.bool.isRequired,
  hideSubmitButton: PropTypes.bool.isRequired,
};

export default ProForm;
